
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-multilevel-dropdown';
import { useEffect } from 'react';
import { setErrorMessage } from "../tools/errorhandling";
import Languageselector from '../tools/language-selector'
import Cookies from 'universal-cookie';
import { myData, getMyNotificationCount, getMyfilteredNotifications, createnotificationread, getLinkedhotels, getserverurl, getEmployer } from '../dbconnector/connector';
import { MdNotifications } from "react-icons/md";
import { VscFile } from "react-icons/vsc";
import { MdOutlineCleaningServices } from "react-icons/md";
import { IoMdCloseCircle } from "react-icons/io";
import { useState } from 'react';
import { BiChevronRight } from "react-icons/bi";
import { RotatingLines } from "react-loader-spinner";
import { AiOutlineFullscreen } from "react-icons/ai";
import { AiOutlineFullscreenExit } from "react-icons/ai";
import Button from 'react-bootstrap/Button';

const logout = () => {
  const cookies = new Cookies();
  cookies.set('logintoken', '', { path: '/' });
}

const Navigatie = (props) => {
  const [notifications, setNotifications] = useState([]);
  const [notificationArray, setnotificationArray] = useState([]);
  const [notificationCount, setnotificationCount] = useState(0);
  const [mylinkedHotelsArray, setmylinkedHotelsArray] = useState([]);
  const [arbeidsregelement, setArbeidsregelement] = useState(null);
  const [linkedhotels, setLinkedhotels] = useState({});
  const [checkedinatwork, setCheckedinatwork] = useState(false)
  const t = props.translation;
  const loggedin = props.loggedIn
  const [user, setUser] = useState({});
  const [languageposition, setLanguageposition] = useState("0px");
  var mobile = require('is-mobile');

  useEffect(() => {
    try {
      if (document.getElementById("IconCleaning") !== null)
        document.getElementById("IconCleaning").style.display = "none";
      if (document.getElementById("IconMyData") !== null)
        document.getElementById("IconMyData").style.display = "none";
      if (document.getElementById("IconMyHoliday") !== null)
        document.getElementById("IconMyHoliday").style.display = "none";
      if (document.getElementById("IconMyContract") !== null)
        document.getElementById("IconMyContract").style.display = "none";
    } catch (e) {
      setErrorMessage(t("error_retreivingData"))
    }
  }, []);




  useEffect(() => {
    getMyData()
    getnotificationcount()
    document.getElementById("Notifications").style.display = "none";

  }, [props]);

  const getMyData = async () => {
    myData().then(res => {
      if (res) {
        setUser({ ...res })
      }
    })

  }
  useEffect(() => {
    getarbeidsregelement(user.werkgever)
  }, [user])

  const getarbeidsregelement = (werkgever) => {
    setArbeidsregelement(null)
    if (werkgever !== null && werkgever !== undefined) {

      getEmployer(werkgever).then(res => {
        try {
          //console.log("werkgever :", res)
          //console.log(res.employer[0].arbeidsregelement)
          setArbeidsregelement(res.employer[0].arbeidsregelement)
        } catch (e) {
          setErrorMessage(t("error_retreivingData"))
        }
      })
    }
  }
  const getnotificationcount = () => {
    // if (user.id !== undefined) {
    //   const count = getMyNotificationCount();
    //   if (count !== null) {
    //     count.then(res => {
    //       if (res.status === 200) {
    //         res.json().then(body => {
    //           setnotificationCount(body[0]['count(*)'])
    //         })
    //       }
    //     })
    //   }
    // }
  }

  const toggleFullScreen = () => {
    const element = document.getElementById("root");
    const isFullScreen = document.fullscreenElement;
    if (isFullScreen) {
      document.exitFullscreen()
      document.getElementById("setfullscreen").style.display = "block";
      document.getElementById("exitfullscreen").style.display = "none";
      sessionStorage.setItem('fullscreen', false)

    } else {
      element.requestFullscreen()
      document.getElementById("setfullscreen").style.display = "none";
      document.getElementById("exitfullscreen").style.display = "block";
      sessionStorage.setItem('fullscreen', true)
    }
  }

  const iconTranslation = {
    Mededeling: (<VscFile className='NotificationIcon' />),
    Work_notification: (<MdOutlineCleaningServices className='NotificationIcon' />),
    Info: (<VscFile className='NotificationIcon' />)
  }

  useEffect(() => {
    setnotificationArray([])
    if (notifications.length > 0) {
      notifications.forEach(notification => {
        setnotificationArray(pre => [...pre,
        <div className="notificationcontainer" id={notification.id}>
          <div className="push__wrapper">
            <div className="push__box">
              <div className="push__content">
                <div className="push__top">
                  <div className="col">
                    <div className="push__imgwrap">
                      {iconTranslation[notification.message_type]}
                    </div>
                    <span className="push__title">{notification.title}</span>

                  </div> <IoMdCloseCircle className='CloseNotification' onClick={() => closenotification(notification.id)} />
                </div>
                <div className="push__main">
                  <div className="push__person">{notification.creator}</div><div className='push__notificationtime'>{new Date(notification.creation_date).toLocaleDateString("en-CA")} {new Date(notification.creation_date).toLocaleTimeString()}</div>
                </div>
                <p className='notificationMessage'>{notification.message}</p>
              </div>
            </div>
          </div>
        </div>
        ])
      });
    } else {
    }
  }, [notifications]);


  useEffect(() => {

    setInterval(() => {
      getnotificationcount();
    }, 30000); // 30000 milliseconds = 30 seconds
    if (user.id !== undefined && user.FK_Rechten_ID !== 1) {
      document.getElementById("mySHC_Linked_Hotels_admin").style.display = "none";
      document.getElementById("FullScreen_LinkedHotels_admin").style.display = "none";
      try {
        const linkedhotels = getLinkedhotels(user.id)
        linkedhotels.then(res => {
          res.json().then(res => {
            setLinkedhotels(res)
          })
        })
      } catch (e) {
        setErrorMessage(t("error_retreivingData"))
      }

    }
  }, [user]);

  const ShowHotelList = async () => {
    if (linkedhotels.length > 0) {
      await CheckIn();
      setmylinkedHotelsArray([]);
      linkedhotels.forEach(hotel => {
        setmylinkedHotelsArray(pre => [...pre, <div className="HotelSelection" onClick={() => SelectHotel(hotel.hotel_Id)} >{hotel.Name}</div>])
      });
      document.getElementById("mySHC_Linked_Hotels_admin").style.display = "Block";
      document.getElementById("checktext").innerText = "Checkin-at-Work, please wait!";
      document.getElementById("FullScreen_LinkedHotels_admin").style.display = "Block";
    } else {
      getMyData()
    }
  }
  const SelectHotel = async (id) => {
    // get the GPS location of the selected hotel and pass it to the CheckIn function.
    // afterwards, Clear the "mySHC_Linked_Hotels_admin" div and hide the div.
    // store the GPS locations in the memory or database. Can be retreived for the checkout (thus avoiding the user to again select the hotel)

    document.getElementById("mySHC_Linked_Hotels_admin").style.display = "none";
    document.getElementById("FullScreen_LinkedHotels_admin").style.display = "none";
    setCheckedinatwork(true)
  }

  const CheckIn = async () => {
    document.getElementById("checkinlink").style.display = "none";
    document.getElementById("checkoutlink").style.display = "block";
    setCheckedinatwork(true)
  }

  const CheckOut = async () => {
    setCheckedinatwork(false)
    document.getElementById("mySHC_Linked_Hotels_admin").style.display = "none";
    document.getElementById("checkinlink").style.display = "block";
    document.getElementById("checkoutlink").style.display = "none";
  }

  const getNotifications = () => {
    // const response = getMyfilteredNotifications();
    // response.then(res => {
    //   if (res.status === 200) {
    //     res.json().then(body => {
    //       setNotifications(pre => [...body])
    //     })
    //   } else {
    //     setErrorMessage(res.statusText)
    //   }
    // });
  }

  const isGenerallyVisible = (element) => {
    const style = document.getElementById("Notifications").style
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0'
  }

  const closenotificationwindow = () => {
    const notificationnode = document.getElementById("Notifications")
    if (notificationnode.style.display === "block") {
      notificationnode.style.display = "none";
    }
  }

  const setlanguageposition = () => {
    setLanguageposition((document.getElementById("languagebutton").offsetLeft) + "px")
  }

  const loadnotification = () => {
    document.getElementById("main").onclick = closenotificationwindow
    getnotificationcount();
    if (isGenerallyVisible(document.getElementById("Notifications"))) {
      document.getElementById("Notifications").style.display = "none";
    } else {
      document.getElementById("Notifications").style.display = "block";
      getNotifications();
    }
    document.getElementById("Notifications").style.left = "0px"
  }

  const closenotification = (id) => {
    document.getElementById(id).style.display = "none";
    loadnotification();
    createnotificationread(id).then(res => {
      if (res.status === 200) {
        setErrorMessage(t("message_readnotificationcreated"))
      } else {
        setErrorMessage(res.statusText)
      }
    });
  }

  const openContract = () => {
    window.open(getserverurl() + user.contract, "_blank")
  }

  const openReglement = () => {
    window.open(getserverurl() + arbeidsregelement, "_blank")
  }

  return (
    <header>
      <div className="fullscreen" id="FullScreen_LinkedHotels_admin" style={{ display: "none" }}>
        <div id="checkinloadingmessage_admin" className="checkingatworkstatusmessage" style={{ display: "none" }}><center>
          <RotatingLines
            strokeColor="grey"
            strokeWidth="5"
            animationDuration="0.75"
            visible={true} className="spinner"
          />
          <br></br><div id="checktext">Checkin-at-Work, please wait!</div></center></div>
        <div className="LinkedHotels" id="mySHC_Linked_Hotels_admin">
          <div className="hoteselectionTitle" >Select your current working place</div>
          {mylinkedHotelsArray}
        </div>
      </div>
      {(props.rights === 2) && (!mobile()) ? (
        <Navbar expand="lg" fixed='top' className='TopNavigatie' >
          <Navbar.Brand href="/" className='Brandlogo'>
            <img
              src="/img/logo_SAM.svg"
              alt="SAM logo"
              className='BrandHeight'
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" >
            <Nav className="me-auto">
              <Dropdown title={t('SUPERVISOR')} position="right" className='menucontainer nav-link'>
                <a href="\Rooster" className='menulink'>
                  <Dropdown.Item className='menuitem'>
                    {t('Rooster')}
                  </Dropdown.Item>
                </a>
                <a href="\NoShow" className='menulink'>
                  <Dropdown.Item className='menuitem'>
                    {t('Afwezigheid melden')}
                  </Dropdown.Item>
                </a>
                <a href="\AssignCleaningTasks" className='menulink'>
                  <Dropdown.Item className='menuitem'>
                    {t('Aanmaaktaken')}
                  </Dropdown.Item>
                </a>
                <a href="\viewcleaningassignments" className='menulink'>
                  <Dropdown.Item className='menuitem'>
                    {t('Overzichttaken')}
                  </Dropdown.Item>
                </a>
                <a href="\Dagstaten" className='menulink'>
                  <Dropdown.Item className='menuitem'>
                    {t('Dagstaten')}
                  </Dropdown.Item>
                </a>
              </Dropdown>
              <Dropdown title={t('ADMINSTRATION')} position="right" className='menucontainer nav-link'>
                <Dropdown.Item className='menuitem'>
                  {t('Medewerkers')} <div className='Menuchevron'><BiChevronRight /></div>
                  <Dropdown.Submenu position="right">
                    <a href="/employees" className='menulink'>
                      <Dropdown.Item  >
                        {t('Overzicht')}
                      </Dropdown.Item>
                    </a>
                    <Dropdown.Item className='Menudevider' />
                    <Dropdown.Item className='menuitem'>
                      {t('Raporten')} <div className='Menuchevron'><BiChevronRight /></div>
                      <Dropdown.Submenu position="right">
                        <a href="/checkins" className='menulink'>
                          <Dropdown.Item>
                            {t('MedewerkersCheck-ins')}
                          </Dropdown.Item>
                        </a>
                        <a href="/activityreport" className='menulink'>
                          <Dropdown.Item>
                            {t('activityreport')}
                          </Dropdown.Item>
                        </a>
                        {/* <a href="/daystats" className='menulink'>
                          <Dropdown.Item>
                            {t('Dagstatistiekmedewerkers')}
                          </Dropdown.Item>
                        </a> */}
                        <a href="/ciaw" className='menulink'>
                          <Dropdown.Item>
                            {t('CIAWtabel')}
                          </Dropdown.Item>
                        </a>
                      </Dropdown.Submenu>
                    </Dropdown.Item>
                    <Dropdown.Item className='Menudevider' />
                    <a href="/holidayrequests" className='menulink'>
                      <Dropdown.Item>
                        {t('Vakantieaanvagen')}
                      </Dropdown.Item>
                    </a>
                    <Dropdown.Item className='Menudevider' />
                    <a href="/HolidayCalendar" className='menulink'>
                      <Dropdown.Item>
                        {t('VakantieCalendar')}
                      </Dropdown.Item>
                    </a>
                      <Dropdown.Item className='Menudevider' />
                    <a href="/Loginlist" className='menulink'>
                      <Dropdown.Item>
                        {t('Loginlist')}
                      </Dropdown.Item>
                    </a>
                  </Dropdown.Submenu>
                </Dropdown.Item>
                <Dropdown.Item className='Menudevider' />
                <Dropdown.Item className='menuitem'>
                  {t('Werkgevers')} <div className='Menuchevron'><BiChevronRight /></div>
                  <Dropdown.Submenu position="right">
                    <a href="/employers/employerlist" className='menulink'>
                      <Dropdown.Item  >
                        {t('Overzicht')}
                      </Dropdown.Item>
                    </a>
                  </Dropdown.Submenu>
                </Dropdown.Item>
                <Dropdown.Item className='Menudevider' />
                <Dropdown.Item className='menuitem'>
                  {t('Hotels')} <div className='Menuchevron'><BiChevronRight /></div>
                  <Dropdown.Submenu position="right">
                    <a href="/hotels" className='menulink'>
                      <Dropdown.Item>
                        {t('Overzicht')}
                      </Dropdown.Item>
                    </a>
                    <Dropdown.Item className='Menudevider' />
                    <a href="/regions" className='menulink'>
                      <Dropdown.Item>
                        {t('Regios')}
                      </Dropdown.Item>
                    </a>
                  </Dropdown.Submenu>
                </Dropdown.Item>
                   <Dropdown.Item className='Menudevider' />
                <Dropdown.Item className='menuitem'>
                  {t('Messages')} <div className='Menuchevron'><BiChevronRight /></div>
                  <Dropdown.Submenu position="right">
                    <a href="/composeemailmessagelist" className='menulink'>
                      <Dropdown.Item  >
                        {t('Overzicht')}
                      </Dropdown.Item>
                    </a>
                  </Dropdown.Submenu>
                </Dropdown.Item>
                {/* <Dropdown.Item className='Menudevider' />
                <Dropdown.Item className='menuitem'>
                  {t('facturatie')}  <div className='Menuchevron'><BiChevronRight /></div>
                  <Dropdown.Submenu position="right">
                    <a href="\invoice" className='menulink'>
                      <Dropdown.Item>
                        {t('Hotels')} (TBD)
                      </Dropdown.Item>
                    </a>
                  </Dropdown.Submenu>
                </Dropdown.Item> */}
                {/* <Dropdown.Item className='Menudevider' />
                <a href="\general" className='menulink'>
                  <Dropdown.Item  >
                    {t('Algemeen')}
                  </Dropdown.Item>
                </a> */}
              </Dropdown>
              <Dropdown style={{ display: props.rights === 2 ? "block" : "none" }} title={"REPORTS & TRIGGERS"} position="right" className='menucontainer nav-link'>
                <a href="\triggers-caches" className='menulink'>
                  <Dropdown.Item className='menuitem'>
                    Triggers & Caches
                  </Dropdown.Item>
                </a>
                <a href="/triggers-reports" className='menulink'>
                  <Dropdown.Item className='menuitem'>
                    Reports
                  </Dropdown.Item>
                </a>
              </Dropdown>
              <Dropdown title={t('MYSHC')} position="right" className='menucontainer nav-link'>
                <a href="\mydata" className='menulink'>
                  <Dropdown.Item className='menuitem'>
                    {t('Mijngegevens')}
                  </Dropdown.Item>
                </a>
                <Dropdown.Item className='Menudevider' />
                <a href="\myholidayrequest" className='menulink'>
                  <Dropdown.Item className='menuitem'>
                    {t('Mijnvakantieaanvragen')}
                  </Dropdown.Item>
                </a>
                <Dropdown.Item className='Menudevider' />
                <a className='menulink' onClick={openContract}>
                  <Dropdown.Item className='menuitem'>
                    {t('MyContract')}
                  </Dropdown.Item>
                </a>
                <div style={arbeidsregelement !== null ? { display: 'block' } : { display: 'none' }}>
                  <Dropdown.Item className='Menudevider' />
                  <a className='menulink' onClick={openReglement}>
                    <Dropdown.Item className='menuitem'>
                      {t('Arbeidsregelement')}
                    </Dropdown.Item>
                  </a>
                </div>
                {/* <Dropdown.Item className='Menudevider' />
                <Dropdown.Item id="checkinlink" className='menuitem' onClick={ShowHotelList} style={checkedinatwork === false ? { display: "block" } : { display: "none" }}>
                  {t('Checkin-at-work')}
                </Dropdown.Item>
                <Dropdown.Item id="checkoutlink" className='menuitem' style={checkedinatwork === true ? { display: "block" } : { display: "none" }} onClick={CheckOut}>
                  {t('Checkout-at-work')}
                </Dropdown.Item> */}
              </Dropdown>
              <Nav.Link onClick={() => logout()} href='/' className='menucontainer'>{t('LOGGOFF')}</Nav.Link>
              {/* <LuFullscreen onClick={() => toggleFullScreen()} /> */}
              <div className='language_logo' onClick={setlanguageposition} id="languagebutton">
                <Languageselector position={languageposition} />
              </div>
              <div id="NotificationIconMenu" className='NotificationIconMenu' onClick={loadnotification}>
                <div id='nr_Ofnotifications' className='NotificationQuantity' style={notificationCount === 0 ? { display: "none" } : { display: "block" }}>{notificationCount}</div>
                <MdNotifications className='NotificationMenu' />
              </div>
              <div className='loggedInUser'>
                {user.achternaam}, {user.voornaam}
              </div>
              {/* <div className='checkedinatwork' style={checkedinatwork === true ? { display: "block" } : { display: "none" }}>
                {t('Checked-in-at-work')}
              </div>
              <div className='checkedoutatwork' style={checkedinatwork === false ? { display: "block" } : { display: "none" }}>
                {t('Checked-out-at-work')}
              </div> */}
              <AiOutlineFullscreen id="setfullscreen" className='fullscreen_logo' onClick={() => toggleFullScreen()} />
              <AiOutlineFullscreenExit id="exitfullscreen" className='fullscreen_logo' onClick={() => toggleFullScreen()} style={{ display: "none" }} />
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      ) : mobile() ? (
        <div className='TopNavigatie'>
          <div className='Brandlogo'>
            <a href="/">
              <img
                src="/img/logo_SAM.svg"
                alt="SAM logo"
                className='BrandHeightPhone'
              />
            </a></div>
          <div className='top_logos' >
            <img
              id="IconCleaning"
              src="/img/ico_CleaningTasks.svg"
              className="Icon_class"
              alt="Cleaning tasks"
            />
            <img
              id="IconMyData"
              src="/img/ico_MyData.svg"
              className="Icon_class"
              alt="My Data"
            />
            <img
              id="IconMyHoliday"
              src="/img/ico_Holiday.svg"
              className="Icon_class"
              alt="My Holiday"
            />
            <img
              id="IconMyContract"
              src="/img/ico_MyContract.svg"
              className="Icon_class"
              alt="My Contract"
            />
          </div>
          <div className='language_logo' id="languagebutton" >
            <Languageselector position={languageposition} />
          </div>
          <div className='loggout_logo' >
            <a onClick={() => logout()} href='/'>
              <img
                id="IconCleaning"
                src="/img/ico_loggout.svg"
                height={30}
                className="Icon_class"
                alt="log-out"
              /></a>
          </div>
          <div className='NotificationIconMenu' onClick={loadnotification}>
            <div id='nr_Ofnotifications' className='NotificationQuantity' style={notificationCount === 0 ? { display: "none" } : { display: "block" }}>{notificationCount}</div>
            <MdNotifications className='NotificationMenu' />
          </div>
        </div>
      )
        : (props.rights === 4) && (!mobile()) ? (
          <Navbar expand="lg" fixed='top' className='TopNavigatie' >
            <Navbar.Brand href="/" className='Brandlogo'>
              <img
                src="/img/logo_SAM.svg"
                alt="SAM logo"
                className='BrandHeight'
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" >
              <Nav className="me-auto">
                <Dropdown title={t('SUPERVISOR')} position="right" className='menucontainer nav-link'>
                  <a href="\NoShow" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Afwezigheid melden')}
                    </Dropdown.Item>
                  </a>
                  <a href="\Rooster" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Rooster')}
                    </Dropdown.Item>
                  </a>
                  <a href="\AssignCleaningTasks" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Aanmaaktaken')}
                    </Dropdown.Item>
                  </a>
                  <a href="\viewcleaningassignments" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Overzichttaken')}
                    </Dropdown.Item>
                  </a>
                </Dropdown>
                <Dropdown title={t('ADMINSTRATION')} position="right" className='menucontainer nav-link'>
                  <Dropdown.Item className='menuitem'>
                    {t('Medewerkers')} <div className='Menuchevron'><BiChevronRight /></div>
                    <Dropdown.Submenu position="right">
                      <a href="/employees" className='menulink'>
                        <Dropdown.Item  >
                          {t('Overzicht')}
                        </Dropdown.Item>
                      </a>
                      <Dropdown.Item className='Menudevider' />
                      <Dropdown.Item className='menuitem'>
                        {t('Raporten')} <div className='Menuchevron'><BiChevronRight /></div>
                        <Dropdown.Submenu position="right">
                          <a href="/checkins" className='menulink'>
                            <Dropdown.Item>
                              {t('MedewerkersCheck-ins')}
                            </Dropdown.Item>
                          </a>
                          {/* <a href="/daystats" className='menulink'>
                          <Dropdown.Item>
                            {t('Dagstatistiekmedewerkers')}
                          </Dropdown.Item>
                        </a>
                        <a href="/ciaw" className='menulink'>
                          <Dropdown.Item>
                            {t('CIAWtabel')}
                          </Dropdown.Item>
                        </a> */}
                        </Dropdown.Submenu>
                      </Dropdown.Item>
                      <Dropdown.Item className='Menudevider' />
                      <a href="/holidayrequests" className='menulink'>
                        <Dropdown.Item>
                          {t('Vakantieaanvagen')}
                        </Dropdown.Item>
                      </a>
                      <Dropdown.Item className='Menudevider' />
                      <a href="/HolidayCalendar" className='menulink'>
                        <Dropdown.Item>
                          {t('VakantieCalendar')}
                        </Dropdown.Item>
                      </a>
                    </Dropdown.Submenu>
                  </Dropdown.Item>
                  <Dropdown.Item className='Menudevider' />
                  {/* <Dropdown.Item className='menuitem'>
                  {t('Hotels')} <div className='Menuchevron'><BiChevronRight /></div>
                  <Dropdown.Submenu position="right">
                    <a href="/hotels" className='menulink'>
                      <Dropdown.Item>
                        {t('Overzicht')}
                      </Dropdown.Item>
                    </a>
                    <Dropdown.Item className='Menudevider' />
                    <a href="/regions" className='menulink'>
                      <Dropdown.Item>
                        {t('Regios')}
                      </Dropdown.Item>
                    </a>
                    {/* <a href="/tarieven" className='menulink'>
                      <Dropdown.Item>
                        {t('Tarieven')}
                      </Dropdown.Item>
                    </a> 
                  </Dropdown.Submenu>
                </Dropdown.Item> */}
                  {/* <Dropdown.Item className='Menudevider' /> */}
                  {/* <Dropdown.Item className='menuitem'>
                  {t('facturatie')}  <div className='Menuchevron'><BiChevronRight /></div>
                  <Dropdown.Submenu position="right">
                  <a href="\invoice" className='menulink'>
                    <Dropdown.Item>
                      {t('Hotels')} (TBD)
                    </Dropdown.Item>
                    </a>
                  </Dropdown.Submenu>
                </Dropdown.Item> */}
                  {/* <Dropdown.Item className='Menudevider' /> */}
                  {/* <a href="\general" className='menulink'>
                  <Dropdown.Item  >
                    {t('Algemeen')}
                  </Dropdown.Item>
                </a> */}
                </Dropdown>
                <Dropdown title={t('MYSHC')} position="right" className='menucontainer nav-link'>
                  <a href="\mydata" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Mijngegevens')}
                    </Dropdown.Item>
                  </a>
                  <Dropdown.Item className='Menudevider' />
                  <a href="\myholidayrequest" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Mijnvakantieaanvragen')}
                    </Dropdown.Item>
                  </a>
                  <Dropdown.Item className='Menudevider' />
                  <a className='menulink' onClick={openContract}>
                    <Dropdown.Item className='menuitem'>
                      {t('MyContract')}
                    </Dropdown.Item>
                  </a>
                  <div style={arbeidsregelement !== null ? { display: 'block' } : { display: 'none' }}>
                    <Dropdown.Item className='Menudevider' />
                    <a className='menulink' onClick={openReglement}>
                      <Dropdown.Item className='menuitem'>
                        {t('Arbeidsregelement')}
                      </Dropdown.Item>
                    </a>
                  </div>
                  {/* <Dropdown.Item className='Menudevider' />
                <Dropdown.Item id="checkinlink" className='menuitem' onClick={ShowHotelList} style={checkedinatwork === false ? { display: "block" } : { display: "none" }}>
                  {t('Checkin-at-work')}
                </Dropdown.Item>
                <Dropdown.Item id="checkoutlink" className='menuitem' style={checkedinatwork === true ? { display: "block" } : { display: "none" }} onClick={CheckOut}>
                  {t('Checkout-at-work')}
                </Dropdown.Item> */}
                </Dropdown>
                <Nav.Link onClick={() => logout()} href='/' className='menucontainer'>{t('LOGGOFF')}</Nav.Link>
                {/* <LuFullscreen onClick={() => toggleFullScreen()} /> */}
                <div className='language_logo' onClick={setlanguageposition} id="languagebutton">
                  <Languageselector position={languageposition} />
                </div>
                <div id="NotificationIconMenu" className='NotificationIconMenu' onClick={loadnotification}>
                  <div id='nr_Ofnotifications' className='NotificationQuantity' style={notificationCount === 0 ? { display: "none" } : { display: "block" }}>{notificationCount}</div>
                  <MdNotifications className='NotificationMenu' />
                </div>
                <div className='loggedInUser'>
                  {user.achternaam}, {user.voornaam}
                </div>
                {/* <div className='checkedinatwork' style={checkedinatwork === true ? { display: "block" } : { display: "none" }}>
                  {t('Checked-in-at-work')}
                </div>
                <div className='checkedoutatwork' style={checkedinatwork === false ? { display: "block" } : { display: "none" }}>
                  {t('Checked-out-at-work')}
                </div> */}
                <AiOutlineFullscreen id="setfullscreen" className='fullscreen_logo' onClick={() => toggleFullScreen()} />
                <AiOutlineFullscreenExit id="exitfullscreen" className='fullscreen_logo' onClick={() => toggleFullScreen()} style={{ display: "none" }} />
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        ) : props.rights === 3 && (!mobile()) ? (
          <Navbar expand="lg" fixed='top' className='TopNavigatie' >
            <Navbar.Brand href="/" className='Brandlogo'>
              <img
                src="/img/logo_SAM.svg"
                alt="SAM logo"
                className='BrandHeight'
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" >
              <Nav className="me-auto">
                <Dropdown title={t('SCHOONMAAK')} position="right" className='menucontainer nav-link'>
                  <a href="\Rooster" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Rooster')}
                    </Dropdown.Item>
                  </a>
                  <a href="\AssignCleaningTasks" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Aanmaaktaken')}
                    </Dropdown.Item>
                  </a>
                  <a href="\viewcleaningassignments" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Overzichttaken')}
                    </Dropdown.Item>
                  </a>
                </Dropdown>

                {/* <Dropdown title={t('RAPPORTERINGEN')} position="right" className='menucontainer nav-link'>
                  <a href="/checkins" className='menulink'>
                    <Dropdown.Item>
                      {t('MedewerkersCheck-ins')}
                    </Dropdown.Item>
                  </a>
                  <a href="/daystats" className='menulink'>
                    <Dropdown.Item>
                      {t('Dagstatistiekmedewerkers')}
                    </Dropdown.Item>
                  </a>
                  <a href="#action/3.1" className='menulink'>
                    <Dropdown.Item>
                      {t('DailyReport')}
                    </Dropdown.Item>
                  </a>
                </Dropdown> */}
                <Dropdown title={t('ADMINSTRATION')} position="right" className='menucontainer nav-link'>
                  <Dropdown.Item className='menuitem'>
                    {t('Medewerkers')} <div className='Menuchevron'><BiChevronRight /></div>
                    <Dropdown.Submenu position="right">
                      <a href="/holidayrequests" className='menulink'>
                        <Dropdown.Item>
                          {t('Vakantieaanvagen')}
                        </Dropdown.Item>
                      </a>
                      <Dropdown.Item className='Menudevider' />
                      <a href="/HolidayCalendar" className='menulink'>
                        <Dropdown.Item>
                          {t('VakantieCalendar')}
                        </Dropdown.Item>
                      </a>
                    </Dropdown.Submenu>
                  </Dropdown.Item>

                </Dropdown>
                <Dropdown title={t('MYSHC')} position="right" className='menucontainer nav-link'>
                  <a href="\mydata" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Mijngegevens')}
                    </Dropdown.Item>
                  </a>
                  <Dropdown.Item className='Menudevider' />
                  <a href="\myholidayrequest" className='menulink'>
                    <Dropdown.Item className='menuitem'>
                      {t('Mijnvakantieaanvragen')}
                    </Dropdown.Item>
                  </a>
                  <Dropdown.Item className='Menudevider' />
                  <a className='menulink' onClick={openContract}>
                    <Dropdown.Item className='menuitem'>
                      {t('MyContract')}
                    </Dropdown.Item>
                  </a>
                  <div style={arbeidsregelement !== null ? { display: 'block' } : { display: 'none' }}>
                    <Dropdown.Item className='Menudevider' />
                    <a className='menulink' onClick={openReglement}>
                      <Dropdown.Item className='menuitem'>
                        {t('Arbeidsregelement')}
                      </Dropdown.Item>
                    </a>
                  </div>
                  <Dropdown.Item className='Menudevider' />
                  <Dropdown.Item id="checkinlink" className='menuitem' onClick={ShowHotelList} style={checkedinatwork === false ? { display: "block" } : { display: "none" }}>
                    {t('Checkin-at-work')}
                  </Dropdown.Item>
                  <Dropdown.Item id="checkoutlink" className='menuitem' style={checkedinatwork === true ? { display: "block" } : { display: "none" }} onClick={CheckOut}>
                    {t('Checkout-at-work')}
                  </Dropdown.Item>
                </Dropdown>
                <Nav.Link onClick={() => logout()} href='/' className='menucontainer'>{t('LOGGOFF')}</Nav.Link>
                <div className='language_logo' onClick={setlanguageposition} id="languagebutton">
                  <Languageselector position={languageposition} />
                </div>
                <div id="NotificationIconMenu" className='NotificationIconMenu' onClick={loadnotification}>
                  <div id='nr_Ofnotifications' className='NotificationQuantity' style={notificationCount === 0 ? { display: "none" } : { display: "block" }}>{notificationCount}</div>
                  <MdNotifications className='NotificationMenu' />
                </div>
                <div className='loggedInUser'>
                  {user.achternaam}, {user.voornaam}
                </div>
                <AiOutlineFullscreen id="setfullscreen" className='fullscreen_logo' onClick={() => toggleFullScreen()} />
                <AiOutlineFullscreenExit id="exitfullscreen" className='fullscreen_logo' onClick={() => toggleFullScreen()} style={{ display: "none" }} />
              </Nav>
            </Navbar.Collapse>
          </Navbar>

        ) : null
      }
      <div className='notifications' id="Notifications" onClick={loadnotification}>
        {notificationArray}
      </div>
    </header>
  )
}
export default Navigatie;